import { connect } from 'react-redux';
import { selectActiveVenueId } from 'selectors/general';
import EmptyState from './EmptyState';

const mapStateToProps = state => ({ venueId: selectActiveVenueId(state) });

export default connect(mapStateToProps)(EmptyState);
